module.exports = __webpack_public_path__ + "static/img/service_banana03.7bab62c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/service_banana03.png
// module id = 6t82
// module chunks = 0